module.exports = __webpack_public_path__ + "img/1-en.263a4dac.png";